import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const checkCui = (payload) => {
  return Api(END_POINTS.checkCui, payload, REQUEST_TYPE.POST);
};

const sendCodeUser = (payload) => {
  return Api(END_POINTS.sendCodeUser, payload, REQUEST_TYPE.POST);
};

const verifyCodeUser = (payload) => {
  return Api(END_POINTS.verifyCode, payload, REQUEST_TYPE.POST);
};

const registerUser = (payload) => {
  return Api(END_POINTS.registerUser, payload, REQUEST_TYPE.POST);
};

const loginUser = (payload) => {
  return Api(END_POINTS.loginUser, payload, REQUEST_TYPE.POST);
};

const forgetPasswordUser = (payload) => {
  return Api(END_POINTS.forgetPasswordUser, payload, REQUEST_TYPE.POST);
};

const changePasswordUser = (payload) => {
  return Api(END_POINTS.changePasswordUser, payload, REQUEST_TYPE.POST);
};

const updateUser = (id, payload) => {
  return Api(`${END_POINTS.updateUser}/${id}`, payload, REQUEST_TYPE.PUT);
};

const getUserNotification = (id) => {
  return Api(
    `${END_POINTS.getUserNotification}?userId=${id}&userType=user`,
    null,
    REQUEST_TYPE.GET
  );
};

const markNotificationRead = (id) => {
  return Api(`${END_POINTS.markReadNotification}/${id}`, null, REQUEST_TYPE.PUT);
};

const sendWaitlistRequest = (payload) => {
  return Api(END_POINTS.joinWaitlist, payload, REQUEST_TYPE.POST);
};

export {
  checkCui,
  sendCodeUser,
  verifyCodeUser,
  registerUser,
  loginUser,
  forgetPasswordUser,
  changePasswordUser,
  updateUser,
  getUserNotification,
  sendWaitlistRequest,
  markNotificationRead,
};
